import React, { Component } from "react";
import { isMobile } from "react-device-detect";

class PrimeExchService extends Component {
  render() {
    return (
      <div style={{ margin: "10px", textAlign: "center" }}>
        {this.props.appVersion === "2" && (
          <div>
            <div
              style={{
                marginTop: "10px",
                marginBottom: "10px"
              }}
            >
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "rgb(30, 101, 144)",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px"
                }}
                onClick={() => {
                  let msgToApp = {
                    actionType: "switchUrl",
                    payload: {
                      url: "https://www.bit.ly/RP_Login"
                    }
                  };

                  if (window && window.ReactNativeWebView) {
                    //console.log("posing autologin message to app");
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify(msgToApp)
                    );
                  }
                }}
              >
                <div>
                  <i className="fa fa-paper-plane"></i> SEND MONEY
                </div>
                <div>ফরম তৈরি করুন</div>
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                marginBottom: "10px"
              }}
            >
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "rgb(30, 101, 144)",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px"
                }}
                onClick={() => {
                  let msgToApp = {
                    actionType: "switchUrl",
                    payload: {
                      url: "https://www.bit.ly/Reigister"
                    }
                  };

                  if (window && window.ReactNativeWebView) {
                    //console.log("posing autologin message to app");
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify(msgToApp)
                    );
                  }
                }}
              >
                <div>
                  <i className="fa fa-paper-plane"></i> REGISTER
                </div>
                <div>ফরম তৈরি করুন</div>
              </div>
            </div>
          </div>
        )}
        {this.props.appVersion !== "2" && (
          <div>
            You are not on the latest version of BCS App. To use this service
            please upgrade to latest vesion from Play Store or App Store.
          </div>
        )}
      </div>
    );
  }
}

export default PrimeExchService;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/PrimeExchService.jsx